import React, { useEffect, useState } from 'react';

const QuantityControl = ({ initialQuantity = 1, minQuantity = 1, submitQty }) => {
    const [quantity, setQuantity] = useState(Math.max(initialQuantity, minQuantity));

    useEffect(() => {
        setQuantity(Math.max(initialQuantity, minQuantity));
    }, [initialQuantity, minQuantity]);

    const incrementQuantity = () => {
        setQuantity(quantity + 1)
        if (submitQty) {
            submitQty(quantity + 1);
        }
    };
    const decrementQuantity = () => {
        const nextQuantity = quantity > minQuantity ? quantity - 1 : quantity;
        setQuantity(nextQuantity)
        if (submitQty) {
            submitQty(nextQuantity);
        }
    };

    return (
        <div className="d-flex rounded-4 overflow-hidden">
            <button
                type="button"
                onClick={decrementQuantity}
                className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-one-600 hover-text-white"
            >
                <i className="ph ph-minus" />
            </button>
            <input
                type="number"
                className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
                value={quantity}
                min={minQuantity}
                readOnly
            />
            <button
                type="button"
                onClick={incrementQuantity}
                className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-one-600 hover-text-white"
            >
                <i className="ph ph-plus" />
            </button>
        </div>
    );
};

export default QuantityControl;
